import { IUserToken } from '../../http/models/models';
import { createFetchingEntity } from '../../utils/effector/creatFetchingEntity';
import UserService from '../../http/services/UserService';

export const $userTokens = createFetchingEntity<IUserToken>({
	requestHandler: async () => (await UserService.getTokens()).data,
	doneDataHandler: (state, payload) => payload,
	useCache: true,
});
